// components
import { HeaderBar} from "./components/HeaderBar/HeaderBar";
new HeaderBar();
import { SideMenu} from "./components/sideMenu/SideMenu";
new SideMenu();
import { Collapse } from "./components/Collapse/Collapse";
new Collapse();
import "./components/GTMDataLayer/GTMDataLayer";

// parts
import { faq } from "./parts/faq";
new faq();

// UI elements
import { BulletItem } from "./ui/bullet";
new BulletItem();
